import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import type {
  CentralMappingCategory,
  CentralMappingMappingEntry,
} from 'lumen/models';

interface TdDeepDiscountSignature {
  Args: {
    column: {
      deepDiscountCategory?: CentralMappingCategory;
      isReadOnly: boolean;
    };
    row: {
      isDeepDiscount: boolean;
      mappingEntry: CentralMappingMappingEntry;
      setCategory: (category: CentralMappingCategory | null) => void;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

export default class HotelSettingsCentralMappingTablesCellsTdDeepDiscount extends Component<TdDeepDiscountSignature> {
  get isChecked(): boolean {
    return this.args.row.isDeepDiscount;
  }

  @action
  toggle(): void {
    const { row, column } = this.args;

    if (this.isChecked) {
      row.setCategory(null);
    } else if (column.deepDiscountCategory) {
      row.setCategory(column.deepDiscountCategory);
    }
  }

  <template>
    <div class="flex items-center">
      <PrismCheckbox
        @checked={{this.isChecked}}
        @disabled={{or @column.isReadOnly @rowMeta.isSelected}}
        @onChange={{this.toggle}}
      />
    </div>
  </template>
}
